import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/LoyaltyService';
import { LoyaltyRepository } from '~repositories/LoyaltyRepository';
import { LoyaltyApiSdk } from '~api/LoyaltyApiSdk';
import { QueryFragments } from '~api/QueryFragments';

export class LoadLoyaltyInfoUseCase {
    private loyaltyRepository: LoyaltyRepository;
    private apiSdk: LoyaltyApiSdk;
    private queryFragments: QueryFragments;

    constructor() {
        this.apiSdk = diContainer.get(serviceNames.loyaltyApiSdk);
        this.queryFragments = diContainer.get(serviceNames.queryFragments);
        this.loyaltyRepository = diContainer.get(serviceNames.loyaltyRepository);
    }

    public async execute() {
        this.apiSdk.setQueryFragments(this.queryFragments);
        await this.loyaltyRepository.fetchLoyaltyInfo();
    }
}
